import {DocumentValue} from '@/model/types';

const getComparableValue = (value: DocumentValue | DocumentValue[]): string => {
  if (Array.isArray(value)) {
    return value.map(v => getComparableValue(v)).join(',');
  }

  if (typeof value === 'string') {
    return value;
  }

  if (value && typeof value === 'object') {
    if ('en' in value && 'fr' in value) {
      return value.en || value.fr || '';
    }

    if ('$template' in value) {
      const template = value.$template;
      return typeof template === 'string' ? template : template.en || template.fr || '';
    }

    if ('$ref' in value) {
      return value.$ref;
    }
  }

  return String(value);
};

export const sortDocumentValues =
  (sort?: 'asc' | 'desc') =>
  (a: DocumentValue | DocumentValue[], b: DocumentValue | DocumentValue[]): number => {
    const aValue = getComparableValue(a);
    const bValue = getComparableValue(b);
    return aValue.localeCompare(bValue) * (sort === 'desc' ? -1 : 1);
  };
